import styled from 'styled-components';
import Message from './Message';

export default styled(Message)`
  width: 100%;
  display: flex;

  .message {
    border-radius: 5px;
    padding: 8px;
    margin-bottom: 12px;
    max-width: 80%;
    min-width: 120px;

    &.driver-skin {
      background-color: white;
      color: var(--grey900);
      position: relative;

      .message__time {
        color: var(--grey700);
      }

      &:before {
        content: '';
        width: 30px;
        height: 30px;
        position: absolute;
        background-color: white;
        clip-path: polygon(50% 0%, 100% 15%, 100% 0);
        left: -26px;
        top: 0;
      }
    }

    &.agent-skin {
      background-color: #f0f5ff;
      color: var(--primary900);
      margin-left: auto;
      position: relative;

      &:before {
        content: '';
        width: 30px;
        height: 30px;
        position: absolute;
        background-color: #f0f5ff;
        clip-path: polygon(50% 0%, 50% 15%, 100% 0);
        right: -10px;
        top: 0;
      }
    }
  }

  .message__content {
    display: flex;
  }

  .message__text {
    max-width: 100%;
    overflow-wrap: break-word;
    white-space: pre-line;
  }

  .message__time {
    margin-left: 10px;
    font-weight: bolder;
    align-self: flex-end;
  }

  .message__image {
    display: block;
    max-width: 300px;
    max-height: 300px;
    border-radius: 4px;
    margin-top: 2px;

    &:hover {
      cursor: pointer;
    }
  }

  .message__author {
    font-weight: bolder;
    display: flex;
  }

  .driver-icon {
    margin-right: 10px;
  }
`;
